// extracted by mini-css-extract-plugin
module.exports = {"trigger":"style_trigger-H49u5"};